import { Pie } from '@ant-design/plots';
import { Grid } from 'antd';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../../redux/store';
import NoDataFound from '../../../../components/NoDataFound/NoDataFound';

const { useBreakpoint } = Grid;

const DijikolayCustomerSummaryChart: FC = () => {
    const { t } = useTranslation('dashboard');
    const screens = useBreakpoint();
    const { dijiKolayChart } = useSelector((state: RootState) => state.dashboard);

    const statusColorMap: Record<string, string> = {
        "İptal": "#FF4D4F",
        "Bekliyor": "#F59E0C",
        "Red Edildi": "#808080",
        "Tamamlandı": "#8BC34B",
        "İşleme Alındı": "#2DB2FE"
    };

    if (!dijiKolayChart.data || dijiKolayChart.data.length === 0) {
        return <NoDataFound />;
    }

    const statusCounts = dijiKolayChart.data.reduce((acc, item) => {
        const status = item.status;
        acc[status] = (acc[status] || 0) + 1;
        return acc;
    }, {} as Record<string, number>);

    const total = dijiKolayChart.data.length;

    const processedData = Object.entries(statusCounts).map(([status, count]) => ({
        type: status,
        value: parseFloat(((count / total) * 100).toFixed(2)),
        originalValue: count,
    }));

    if (processedData.length === 0) {
        return <NoDataFound />;
    }

    const config = {
        appendPadding: 10,
        data: processedData,
        angleField: 'value',
        colorField: 'type',
        scale: {
            color: {
                domain: Object.keys(statusColorMap),
                range: Object.values(statusColorMap),
            },
        },
        label: {
            text: 'value',
            formatter: (value: number) => `%${value}`,
            style: {
                fontSize: 8,
                fontWeight: 'bold',
            },
        },
        tooltip: (d: any) => ({
            name: d.type,
            value: `${d.originalValue} ${t('customers')}`,
        }),
        legend: {
            color: {
                title: false,
                position: 'right' as const,
            },
        },
        height: screens.xxl ? 220 : 180,
    };

    return <Pie {...config} />;
};

export default DijikolayCustomerSummaryChart;